import React from "react";
import { ItemCard } from "@coworker/apprestructured/src/shared/components/item-cards/ItemCard/ItemCard";
import { ItemImage } from "@coworker/apprestructured/src/shared/components/item-cards/ItemImage/ItemImage";
import { ItemName } from "@coworker/apprestructured/src/shared/components/item-cards/ItemName/ItemName";
import { ItemNoWithCopy } from "@coworker/apprestructured/src/shared/components/item-cards/ItemNoWithCopy/ItemNoWithCopy";
import { ItemPieces } from "@coworker/apprestructured/src/shared/components/item-cards/ItemPieces/ItemPieces";
import FurnitureSetIconPath from "@ingka/ssr-icon/paths/furniture-set";
import { ItemWithPieces } from "@coworker/apprestructured/src/shared/types/item";
import styles from "../../../styles/common-styles.module.css";

interface ItemCardWithPiecesLocalCombinationProps {
  item: ItemWithPieces;
}

export const ItemCardWithPiecesLocalCombination = ({
  item,
}: ItemCardWithPiecesLocalCombinationProps) => {
  return (
    <ItemCard>
      <div className={styles["item-card-root-row"]}>
        <ItemImage imageUrl={""} fallbackImageIcon={FurnitureSetIconPath} />
        <div className={styles["item-card-root-column"]}>
          <ItemName name={item.name} />
          <ItemNoWithCopy itemNo={item.noFormatted} />
          <ItemPieces pieces={item.pieces ?? 0} />
        </div>
      </div>
    </ItemCard>
  );
};
